import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const SpecializationResourceStore = new ResourceStore(
    'data/specialization.json',
);
